<div class="editor-toolbox">
  <div class="et-label">Editor Toolbox</div>
  <h3 class="margin-top-0" [innerHtml]="heading" *ngIf="heading"></h3>
  <p  [innerHtml]="detail" *ngIf="detail"></p>
  <div class="et-buttons">
    <ng-content></ng-content>
  </div>
</div>
